import { BOOKING_TYPE } from 'constants/booking_types';
import { PROPERTY_CHANNELS } from 'constants/property_channels';

const isCarProperty = (propertyType?: string): boolean => {
  return propertyType === PROPERTY_CHANNELS.CAR || propertyType === BOOKING_TYPE.VEHICLE;
};

export default isCarProperty;
